import sublimationPrinting from "./templates/sublimation-printing";
import image1 from "../../assets/images/materials/cup/1.jpg";
import image2 from "../../assets/images/materials/cup/2.jpg";
import image3 from "../../assets/images/materials/cup/3.jpg";
import image4 from "../../assets/images/materials/cup/4.jpg";
import image5 from "../../assets/images/materials/cup/5.jpg";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Превосходная кружка объемом 250 мл для повседневного использования. Это не просто красивый сувенир, но еще и полезная вещь дома и на работе. Такая кружка позволит вам выделиться из толпы или сделать незабываемый подарок на любой праздник или даже без повода.</p>
      `,
      images: [
        {source: image1},
        {source: image2},
        {source: image3},
        {source: image4},
        {source: image5}
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
